// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"599":"c132bf7d","652":"273acdc0","688":"badf541d","974":"f9a5ee2b"}[chunkId] || chunkId) + "." + {"10":"1d3035913fd88142","134":"01af0fa531baf048","599":"70176c997363fa3e","652":"3d42e168dc880b07","688":"075d904c34513cf3","783":"0689aef2d82a7dc8","974":"b482858c6dab5c27"}[chunkId] + ".js";
};